
import atmosphereMaskApply from '../views/atmosphere-mask/apply'
import atmosphereMaskConfirm from '../views/atmosphere-mask/confirm'
import atmosphereMaskNotice from '../views/atmosphere-mask/notice'
import atmosphereMaskIndex from '../views/atmosphere-mask/index'
import atmosphereMaskReserv from '../views/atmosphere-mask/reserv'
import atmosphereMaskShare from '../views/atmosphere-mask/share'
import atmosphereMaskReservComp from '../views/atmosphere-mask/complete'
import atmosphereMaskShareComp from '../views/atmosphere-mask/shareComplete'
// import atmosphereMask from './atmosphereMask.js'

export default [
    {
      path: '/old/atmosphere-mask-apply',
      name: 'atmosphere-mask-apply',
      component: atmosphereMaskApply
    },
    {
      path: '/old/atmosphere-mask-confirm',
      name: 'atmosphere-mask-confirm',
      component: atmosphereMaskConfirm
    },
    {
      path: '/old/atmosphere-mask-notice',
      name: 'atmosphere-mask-notice',
      component: atmosphereMaskNotice
    },
    {
      path: '/old/atmosphere-mask-index',
      name: 'atmosphere-mask-index',
      component: atmosphereMaskIndex
    },
    {
      path: '/old/atmosphere-mask-reservations',
      name: 'atmosphere-mask-reservations',
      component: atmosphereMaskReserv
    },
    {
      path: '/old/atmosphere-mask-share',
      name: 'atmosphere-mask-share',
      component: atmosphereMaskShare
    },
    {
      path: '/old/atmosphere-mask-reservations-complete/:reservation',
      name: 'atmosphere-mask-reservations-complete',
      component: atmosphereMaskReservComp
    },
    {
      path: '/old/atmosphere-mask-share-complete/:reservation',
      name: 'atmosphere-mask-share-complete',
      component: atmosphereMaskShareComp
    },
  ]


// WEBPACK FOOTER //
// ./src/router/atmosphere.js